export  const baseURL = 'https://api.caxiasesporteclube.com.br/'
// export  const baseURL = 'http://localhost:3003/'

